var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTiktokMobileFavorite = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 28,
  height: 31.004,
  viewBox: "0 0 28 31.004",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M3.5 0h21A3.5 3.5 0 0 1 28 3.5v25.753a1.75 1.75 0 0 1-2.771 1.421L14.68 23.092a1.17 1.17 0 0 0-1.362 0L2.771 30.674A1.75 1.75 0 0 1 0 29.254V3.5A3.5 3.5 0 0 1 3.5 0"
})));
export default SvgTiktokMobileFavorite;